var map = {
	"./1.jpg": "0dac",
	"./1/a_kyurkchiev.jpg": "13ed",
	"./1/bg.jpg": "408b",
	"./1/g.sabev.jpg": "abfc",
	"./1/g_angelov.jpg": "ef93",
	"./1/i_dobrev.jpg": "b080",
	"./1/m_chalakov.jpg": "a2fb",
	"./1/m_gurkopashova.jpg": "1433",
	"./1/n_starev.jpg": "0bca",
	"./1/o_nachkov.jpg": "233d",
	"./1/p_semerdjiev.jpg": "b181",
	"./1/s_hristova.jpg": "e1db",
	"./1/s_pehlivanov.jpg": "425c",
	"./1/s_stoichev.jpg": "8e9e",
	"./1/tsonev.jpg": "be1f",
	"./1/y_kehayov.jpg": "cc67",
	"./10.jpg": "5973",
	"./10/a_Kyurkchiev.jpg": "2c48",
	"./10/a_bairaktarov.jpg": "6fb1",
	"./10/a_kochian.jpg": "559f",
	"./10/bg.jpg": "8e85",
	"./10/i_dobrev.jpg": "791b",
	"./10/r_angelov.jpg": "8dd0",
	"./10/s_atanasov.jpg": "6dcc",
	"./10/s_sirakov.jpg": "adc7",
	"./10/tsonev.jpg": "8254",
	"./11.jpg": "15dc",
	"./11/bg.jpg": "2452",
	"./12.jpg": "eca9",
	"./12/bg.jpg": "ab76",
	"./2.jpg": "d0e5",
	"./2/bg.jpg": "5ed8",
	"./2/d_cherniaev.jpg": "106c",
	"./3.jpg": "6c7d",
	"./3/bg.jpg": "c52b",
	"./3/g_Angelov.jpg": "55371",
	"./3/m_chalakov.jpg": "0fd4",
	"./4.jpg": "5981",
	"./4/a_konov.jpg": "fdc4",
	"./4/bg.jpg": "8da2",
	"./5.jpg": "90bf",
	"./5/bg.jpg": "024a",
	"./5/cv_todorov.jpg": "336f",
	"./5/i_boinovski.jpg": "5598",
	"./5/n_kazakov.jpg": "cd63",
	"./6.jpg": "9a81",
	"./6/bg.jpg": "70d8",
	"./6/i_piskova.jpg": "1c5b",
	"./7.jpg": "56ac",
	"./7/bg.jpg": "7c07",
	"./7/g_papratilov.jpg": "0d0f",
	"./7/v_choinev.jpg": "0c63",
	"./8.jpg": "0cea",
	"./8/a_dmitrova.jpg": "9352",
	"./8/bg.jpg": "aab8",
	"./8/g_papratilov.jpg": "a864",
	"./9.jpg": "b76b",
	"./9/a_marinski.jpg": "d08a",
	"./9/bg.jpg": "64df",
	"./9/d_dalemski.jpg": "2901",
	"./9/e_shondrev.jpg": "2804",
	"./9/n_marudova.jpg": "83a0",
	"./9/o_kutinchev.jpg": "0126",
	"./9/s_pehlivanov.jpg": "dc2f",
	"./no_img.jpg": "35cb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c819";